<template>
    <div class="container-fluid">

        <div class="row">
            <div class="col-10 py-3 bg-fafafa">

                <breadcrumb />

                <div class="card card-body mb-3">

                    <div class="row">
                        <div class="col-lg-12 d-flex align-items-center justify-content-center">
                            <h3 class="f-size-2_2-em">
                                Aggiorna Stato ricette 
                            </h3>
                            <hr>
                            <p class="m-lg-0 text-muted f-size-0_8-em">
                                Questa procedura permette di aggiornare lo stato di avanzamento della ricetta dematerializzata. L'operazione potrebbe richiedere alcuni minuti. 
                            </p>
                        </div>
                        <div class="col-lg-3 d-flex align-items-center justify-content-center mt-3">
                            <span v-show="!loaders.creating">
                                <button type="button" class="btn btn-ifo btn-block btn-lg rounded-0" :disabled="loaders.creating" @click="toggleLogin()">Esegui</button>
                            </span>
                            <div v-show="loaders.creating" class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>

        <div v-if="showLogin" class="login-popup">
            <div>
                <input type="text" v-model="username" placeholder="Username" />
                <br />
                <input type="password" v-model="password" placeholder="Password" class="mt-2" />

                <label class="mt-2">
                    <input type="checkbox" v-model="rememberMe" />
                    Ricordami
                </label>
                <br />
                <button @click="submitLogin" class="btn btn-ifo mt-2">Aggiorna</button>
                <button @click="toggleLogin" class="btn btn-ifo mt-2 ml-3">Chiudi</button>
            </div>    
        </div>                                                                                   

    </div>
</template>

<script>

    import moment   from 'moment'

    // Set lingua
    moment.locale("IT")

    export default {
        data() {
            return {
                showLogin:              false,
                array_first:            [],                     
                ricetta_prestazioni:    [], 
                arrayCheckFirst:        [],
                loaders: {
                    creating: false
                },                
            }
        },
        methods: {
            toggleLogin() {
                this.showLogin = !this.showLogin;          
            },
            submitLogin(event) {
                if (this.username && this.password) {
                    this.showLogin = false;
                    if (this.rememberMe) {
                        localStorage.setItem('rememberedLogin', 'true');
                        localStorage.setItem('username', this.username);
                        localStorage.setItem('password', this.password);
                    } else {
                        localStorage.removeItem('rememberedLogin');
                        localStorage.removeItem('username');
                        localStorage.removeItem('password');
                    }
                    this.update(this.username, this.password);
                } else {
                    event.preventDefault();
                }
            },                                                         
            async update(username, password) {

                 try {

                    this.loaders.creating = true

                    this.parsedDataRicetta = []

                    const ricette = await this.axios.get(`user/ricetta/read/all/${username}/${password}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricette.data.msg,
                        type:   `success`
                    })

                    this.loaders.creating = false

                    this.$router.go(this.$router.currentRoute)

                }
                catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })

                    this.loaders.creating = false

                }
                
            },       
        },

        mounted() {
        }
    }
</script>